import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import $ from 'jquery';
import GopYApi from '../../api/GopYApi';
import Draggable from 'react-draggable';

export const GopY = (props) => {

    const { handleSubmit, register, reset, errors } = useForm();
    const [guiThanhCong, setGuiThanhCong] = useState(false);

    const handleClose = () => {
        $('#modalgopy').modal('hide');
        $('#modalgopy').modal('dispose');
        props.handleClose();
    }

    useEffect(() => {
        reset({
            IdGopY: 0
        }, [reset]);
        if (props.show) {
            $('#modalgopy').modal('show');
        }
    }, [props.show]);

    const saveData = (data) => {
        data.Delete=false;
        data.CreatedDate=new Date();
        if (data.IdGopY === "0") {
            GopYApi.post(data).then(() => {
                setGuiThanhCong(true);
                // setShow(false);
                // loadPosts();
            })
        }
    }

    return (
        <Draggable handle=".modal-header">
            <div className="modal modal-custom" id="modalgopy" tabIndex={-1} data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Góp ý</h5>
                            <button type="button" className="close" onClick={handleClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form className="user" onSubmit={handleSubmit(saveData)}>
                                <input name="IdGopY" hidden={true} ref={register}></input>
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label text-right">Tiêu đề <span className="text-danger">*</span></label>
                                    <div className="col-sm-10">
                                        <input name="TieuDe" type="text" className="form-control" placeholder="Nhập tiêu đề" ref={register({ required: true })} />
                                        {errors.TieuDe && <span className="text-danger">Hãy nhập dữ liệu</span>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label text-right">Họ và tên <span className="text-danger">*</span></label>
                                    <div className="col-sm-10">
                                        <input name="HoTen" type="text" className="form-control" placeholder="Nhập họ và tên" ref={register({ required: true })} />
                                        {errors.HoTen && <span className="text-danger">Hãy nhập dữ liệu</span>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label text-right">Điện thoại</label>
                                    <div className="col-sm-4">
                                        <input name="DienThoai" type="text" className="form-control" placeholder="Nhập điện thoại" ref={register} />
                                    </div>
                                    <label className="col-sm-2 col-form-label text-right">Email <span className="text-danger">*</span></label>
                                    <div className="col-sm-4">
                                        <input name="Email" type="text" className="form-control" placeholder="Nhập email" ref={register({
                                            required: true,
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: "Sai định dạng email"
                                            }
                                        })} />
                                        <span className="text-danger">{errors.Email && errors.Email.message}</span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label text-right">Nội dung <span className="text-danger">*</span></label>
                                    <div className="col-sm-10">
                                        <textarea rows="5" name="NoiDung" type="text" className="form-control" placeholder="Nhập nội dung" ref={register({ required: true })} />
                                        {errors.NoiDung && <span className="text-danger">Hãy nhập dữ liệu</span>}
                                        {guiThanhCong && <span className="text-success">Cảm ơn bạn đã gửi ý kiến góp ý.</span>}
                                    </div>
                                </div>

                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="success" className="btn btn-success btn-sm" onClick={handleSubmit(saveData)} disabled={guiThanhCong}><i className="fas fa-plus"></i> Gửi góp ý</button>
                            <button type="button" className="btn btn-danger btn-sm" onClick={handleClose}><i className="fas fa-sign-out-alt"></i> Đóng</button>

                        </div>
                    </div>
                </div>
            </div>
        </Draggable>
    )
}
